import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MappingDialogData<T> {
  entityName: string;
  entityLabel: string;
  items: T[];
  selectedIds: string[];
  getItemId: (item: T) => string;
  getItemLabel: (item: T) => string;
}

@Component({
  selector: 'app-mapping-dialog',
  standalone: false,
  templateUrl: './mapping-dialog.html',
  styleUrls: ['./mapping-dialog.css']
})
export class MappingDialog<T> implements OnInit {
  searchQuery = '';
  selectedIds: Set<string>;

  constructor(
    public dialogRef: MatDialogRef<MappingDialog<T>>,
    @Inject(MAT_DIALOG_DATA) public data: MappingDialogData<T>
  ) {
    this.selectedIds = new Set(data.selectedIds);
  }

  ngOnInit(): void {}

  get filteredItems() {
    if (!this.searchQuery) return this.data.items;
    const lowerQuery = this.searchQuery.toLowerCase();
    return this.data.items.filter(item => 
      this.data.getItemLabel(item).toLowerCase().includes(lowerQuery)
    );
  }

  toggleSelection(id: string) {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
  }

  onSave() {
    this.dialogRef.close(Array.from(this.selectedIds));
  }
}
